module.exports = __webpack_public_path__ + "static/img/b-4.b5acc36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/b-4.png
// module id = 1WhQ
// module chunks = 0